import BaseContainer from "@base/container/BaseContainer";
import {Signals} from "@/Imports";
import * as PIXI from "pixi.js";
import Facade from "@/Facade";
import Linear from "gsap";
import {calculateTimeToMakeBets} from "@/managers/comunication/socket/utils";
import Config from "@/config/Config";
import LocalizedPIXIText from "@localisation/LocalizedPIXIText";

export default class MakeBetsContainer extends BaseContainer {

  constructor(data) {
    super(data)

    this.progressHeight = 5
    this.progressWidth = 500
    this.progressRound = 10

    this.init()
  }

  init(data) {
    this.o = {
      t: 0
    }
    this.isStarted = false
    this.startPos = 0

    Signals.forceRoundStart.add(this.onRoundStart, this)
    Signals.roundEnd.add(this.onRoundEnd, this)
    Signals.makeBets.add(this.onMakeBets, this)

    this.alpha = 0

    this.createMakeBetsText()

    this.progressBarContainer = new PIXI.Container()
    this.addChild(this.progressBarContainer)

    const progressBarBack = new PIXI.Graphics()
    progressBarBack.beginFill(0x293038)
    progressBarBack.drawRoundedRect(0, 0, this.progressWidth, this.progressHeight, this.progressRound)
    progressBarBack.endFill()
    progressBarBack.pivot.set(progressBarBack.width / 2, progressBarBack.height / 2)
    this.progressBarContainer.addChild(progressBarBack)

    this.progressBar = new PIXI.Graphics()
    this.progressBarContainer.addChild(this.progressBar)
    this.progressBar.position.set(-(this.progressWidth/2), 0)

    this.progressBarContainer.y = 60

  }

  onProgress(percent) {
    this.progressBar.clear()
    this.progressBar.beginFill(0xce0808)
    this.progressBar.drawRoundedRect(0, 0, (percent) * this.progressWidth/100, this.progressHeight, this.progressRound)
    this.progressBar.endFill()
    this.progressBar.pivot.set(0, this.progressBar.height / 2)
  }

  onMakeBets() {
    this.createMakeBetsText()
    this.etalon = calculateTimeToMakeBets(Facade.model.totalTimeToMakeBets, Config.timeForExplosion)
    this.time = calculateTimeToMakeBets(Facade.model.makeBetsTime, Config.timeForExplosion)
    this.startPos = this.time < this.etalon ? 100 - ((this.time / this.etalon) * 100) : 0
    this.onProgress(this.startPos)
    TweenMax.to(this, .2, {alpha: 1})

    this.o.t = this.startPos
    TweenMax.to(this.o, this.time, {t: 100, ease:Linear.easeNone, onUpdate: () => {
      this.onProgress(this.o.t)
        if(this.o.t > 90 && !this.isStarted) {
          this.isStarted = true
          Signals.startPlane.dispatch()
        }
      }})
  }

  onRoundStart() {
    this.createMakeBetsText()
    TweenMax.to(this, .2, {alpha: 0})
  }

  onRoundEnd() {
    this.createMakeBetsText()
    this.isStarted = false
  }

  createMakeBetsText() {
    let {makeBetsText, makeBetsTextShadow} = this

    if (makeBetsText && makeBetsText.parent === this) {
      this.removeChild(makeBetsText)
      makeBetsText = null

      this.removeChild(makeBetsTextShadow)
      makeBetsTextShadow = null
    }

    const text = Facade.textFactory.getLocalizedText('makeBets')
    let style = Facade.textFactory.getStyle('multiplierShadow')

    //HACK TO FIX BESPOKE FONT FROM BEING CUR IN GEORGIAN
    if(Facade.locale === "ka"){
      style.fontFamily = 'Arial'
    }

    this.makeBetsTextShadow = new LocalizedPIXIText(text, style)
    this.addChild(this.makeBetsTextShadow)
    this.makeBetsTextShadow.pivot.set(this.makeBetsTextShadow.width / 2, this. makeBetsTextShadow.height / 2)
    this.makeBetsTextShadow.x += 4
    this.makeBetsTextShadow.y += 4

    style = Facade.textFactory.getStyle('multiplier')

    //HACK TO FIX BESPOKE FONT FROM BEING CUR IN GEORGIAN
    if(Facade.locale === "ka"){
      style.fontFamily = 'Arial'
    }

    this.makeBetsText = new LocalizedPIXIText(text, style)
    this.addChild(this.makeBetsText)
    this.makeBetsText.pivot.set(this.makeBetsText.width / 2, this. makeBetsText.height / 2)
  }
}

